<template>
  <div :class="['platform-badges', { 'platform-badges--two-up': !recoWidgetSrc }]">
    <div class="platform-badges__item platform-badges__item--trustpilot">
      <trustpilot-badge
        :average-rating="averageRating"
        :number-of-ratings="numberOfRatings"
        :reviews-url="reviewsUrl"
      />
    </div>

    <template v-if="recoWidgetSrc">
      <div class="platform-badges__divider" aria-hidden="true" />

      <div class="platform-badges__item platform-badges__item--reco">
        <div class="platform-badges__reco-wrap">
          <div :id="recoMountId" class="platform-badges__reco-widget" />
          <a
            v-if="reviewsUrl"
            :href="reviewsUrl"
            class="platform-badges__reco-overlay"
            aria-label="Reco"
          />
        </div>
      </div>
    </template>

    <div class="platform-badges__divider" aria-hidden="true" />

    <div class="platform-badges__item platform-badges__item--google">
      <google-badge :rating="googleRating" :url="reviewsUrl" />
    </div>
  </div>
</template>

<script>
import TrustpilotBadge from './TrustpilotBadge.vue';
import GoogleBadge from './GoogleBadge.vue';

export default {
  name: 'PlatformBadges',

  components: {
    TrustpilotBadge,
    GoogleBadge,
  },

  props: {
    averageRating: {
      type: String,
      default: null,
    },
    numberOfRatings: {
      type: String,
      default: null,
    },
    reviewsUrl: {
      type: String,
      default: '',
    },
    recoWidgetSrc: {
      type: String,
      default: '',
    },
    recoMountId: {
      type: String,
      default: 'reco--badge-2026',
    },
    googleRating: {
      type: String,
      default: '',
    },
  },

  mounted() {
    if (!this.recoWidgetSrc) {
      return;
    }
    // The src comes from a WP options field — locking it to widget.reco.se
    // defends against a misconfigured/compromised admin entry from injecting
    // an arbitrary third-party script.
    let parsedUrl;
    try {
      parsedUrl = new URL(this.recoWidgetSrc, window.location.origin);
    } catch {
      return;
    }
    if (parsedUrl.protocol !== 'https:' || parsedUrl.hostname !== 'widget.reco.se') {
      return;
    }
    const normalizedSrc = parsedUrl.toString();
    // Always re-inject: the widget script populates the mount on execution,
    // so a stale tag from a prior mount/HMR cycle leaves the new div empty.
    [...document.scripts]
      .filter((node) => node.src === normalizedSrc)
      .forEach((node) => node.remove());
    const script = document.createElement('script');
    script.src = normalizedSrc;
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>
